export class OrgClockWorkRightsModel {
    constructor() {
        this.teams = [];
    }
}
export default class OrgClockWorkRights extends OrgClockWorkRightsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
